import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const ConsumerResearch = lazy(() => import('../pages/services/consumer-research/page'));
const DigitalCollection = lazy(() => import('../pages/services/digital-collection/page'));
const FieldOperations = lazy(() => import('../pages/services/field-operations/page'));
const RetailIntelligence = lazy(() => import('../pages/services/retail-intelligence/page'));
const DataQuality = lazy(() => import('../pages/data-quality/page'));
const Coverage = lazy(() => import('../pages/coverage/page'));
const Technology = lazy(() => import('../pages/technology/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const FieldNetwork = lazy(() => import('../pages/field-network/page'));
const Clients = lazy(() => import('../pages/clients/page'));
const EngagementModels = lazy(() => import('../pages/engagement-models/page'));
const CaseStudies = lazy(() => import('../pages/case-studies/page'));
const Insights = lazy(() => import('../pages/insights/page'));
const RetailAuditNigeria = lazy(() => import('../pages/insights/articles/retail-audit-nigeria'));
const FieldResearchMethodology = lazy(() => import('../pages/insights/articles/field-research-methodology-west-africa'));
const ConsumerSurveyAfrica = lazy(() => import('../pages/insights/articles/consumer-survey-data-collection-africa'));
const MarketResearchCosts = lazy(() => import('../pages/insights/articles/market-research-costs-africa'));
const VerifyFieldAgentData = lazy(() => import('../pages/insights/articles/how-to-verify-field-agent-data-africa'));
const AfricanMarketEntryUK = lazy(() => import('../pages/insights/articles/african-market-entry-research-uk-europe'));
const CommissionRemotely = lazy(() => import('../pages/insights/articles/how-to-commission-field-research-africa-remotely'));
const InternationalClients = lazy(() => import('../pages/international-clients/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services/consumer-research',
    element: <ConsumerResearch />,
  },
  {
    path: '/services/digital-collection',
    element: <DigitalCollection />,
  },
  {
    path: '/services/field-operations',
    element: <FieldOperations />,
  },
  {
    path: '/services/retail-intelligence',
    element: <RetailIntelligence />,
  },
  {
    path: '/data-quality',
    element: <DataQuality />,
  },
  {
    path: '/coverage',
    element: <Coverage />,
  },
  {
    path: '/technology',
    element: <Technology />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/field-network',
    element: <FieldNetwork />,
  },
  {
    path: '/clients',
    element: <Clients />,
  },
  {
    path: '/engagement-models',
    element: <EngagementModels />,
  },
  {
    path: '/case-studies',
    element: <CaseStudies />,
  },
  {
    path: '/insights',
    element: <Insights />,
  },
  {
    path: '/insights/how-to-run-retail-audit-nigeria',
    element: <RetailAuditNigeria />,
  },
  {
    path: '/insights/field-research-methodology-west-africa',
    element: <FieldResearchMethodology />,
  },
  {
    path: '/insights/consumer-survey-data-collection-africa',
    element: <ConsumerSurveyAfrica />,
  },
  {
    path: '/insights/market-research-costs-africa',
    element: <MarketResearchCosts />,
  },
  {
    path: '/insights/how-to-verify-field-agent-data-africa',
    element: <VerifyFieldAgentData />,
  },
  {
    path: '/insights/african-market-entry-research-uk-europe',
    element: <AfricanMarketEntryUK />,
  },
  {
    path: '/insights/how-to-commission-field-research-africa-remotely',
    element: <CommissionRemotely />,
  },
  {
    path: '/international-clients',
    element: <InternationalClients />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;